// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__eiup7","title":"styles_title__tXaoU","description":"styles_description__hje7L"};